var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Policy Corner',
      "subTitleText": 'Policies serve as the framework governing interactions across government and between the public and private sector. Standardizing the methodology for specific interactions and transactions between government and industry provides a universal framework by which all organizations doing business with the government must operate. Effective policies inform decision-makers on critical items such as resource allocation, staffing, and business development.'
    }
  })], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-5 section-content"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-md-5 px-lg-5"
  }, _vm._l(_vm.policyData, function (policy) {
    return _c('div', {
      key: policy.policyCode,
      staticClass: "w-100 policy-data-row policy-data-border row m-0 p-0 mb-3"
    }, [_c('div', {
      staticClass: "policy-data-text policy-name px-3 col-12 col-md-3 col-lg-3 col-xl-3 p-0 d-flex justify-content-start justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center text-start text-md-center text-lg-center tex-xl-center"
    }, [_vm._v(" " + _vm._s(policy.policyName) + " ")]), _c('div', {
      staticClass: "policy-data-border col-12 col-md-9 col-lg-9 col-xl-9 p-0"
    }, [_c('div', {
      staticClass: "row h-100 m-0 p-1 p-md-0 p-lg-0 p-xl-0"
    }, [_c('div', {
      staticClass: "policy-data-text policy-summary px-3 py-2 py-md-0 py-lg-0 py-xl-0 col-12 col-md-9 col-lg-10 col-xl-10 p-0 d-flex flex-column justify-content-center"
    }, [_c('div', {
      staticClass: "text-start limit-lines-1",
      staticStyle: {
        "height": "auto"
      }
    }, [_vm._v(" " + _vm._s(policy.policySummary) + " ")])]), _c('div', {
      staticClass: "col-12 col-md-3 col-lg-2 col-xl-2 p-0 pb-2 pb-md-0 pb-lg-0 pb-xl-0 d-flex justify-content-center align-items-center"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'policy-corner-info',
          query: {
            policyCode: policy.policyCode
          }
        }
      }
    }, [_c('v-btn', {
      attrs: {
        "rounded": "",
        "large": "",
        "dark": "",
        "color": '#424EC4'
      }
    }, [_vm._v(" Read More ")])], 1)], 1)])])]);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }